module.exports = __webpack_public_path__ + "static/img/sw_qw_3.bae05e4a.png";